import { render, staticRenderFns } from "./EditCustomGoalInitialAmount.vue?vue&type=template&id=bd4a812e&scoped=true&"
import script from "./EditCustomGoalInitialAmount.vue?vue&type=script&lang=ts&"
export * from "./EditCustomGoalInitialAmount.vue?vue&type=script&lang=ts&"
import style0 from "./EditCustomGoalInitialAmount.vue?vue&type=style&index=0&id=bd4a812e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4a812e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VForm,VRadio,VRadioGroup,VRow,VTextField})
